export interface ApplicationModelInterface {
  selectedRoomId: string | undefined;
  selectedUserId: string | 'publicLink' | undefined;
  selectedAssetId: string | undefined;
  selectedWidgetId: string | undefined;
}
